import List from 'containers/LeadActivities';

export default { List };
